import { useState, useMemo } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import { api } from '../api/client.js';

export default function ResetPassword() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const token = useMemo(() => searchParams.get('token') || '', [searchParams]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');

    if (!token) {
      setError('Chybí token pro obnovu hesla.');
      return;
    }
    if (password.length < 8) {
      setError('Heslo musí mít alespoň 8 znaků.');
      return;
    }
    if (password !== confirm) {
      setError('Hesla se neshodují.');
      return;
    }

    setSubmitting(true);

    try {
      await api.post('/auth/reset-password', { token, password });
      navigate('/login', { replace: true });
    } catch (err) {
      setError(err.response?.data?.message || err.message || 'Heslo se nepodařilo obnovit.');
    } finally {
      setSubmitting(false);
    }
  };

  if (!token) {
    return (
      <div className="auth">
        <h1 className="auth__title">Neplatný odkaz</h1>
        <p className="auth__subtitle">Tento odkaz pro obnovu hesla není platný.</p>
        <Link to="/login" className="button button--primary">Přejít na přihlášení</Link>
      </div>
    );
  }

  return (
    <div className="auth">
      <h1 className="auth__title">Nové heslo</h1>
      <p className="auth__subtitle">Zadejte nové heslo pro svůj účet.</p>

      <form className="auth__form" onSubmit={handleSubmit}>
        <label className="auth__label">
          Nové heslo
          <input
            className="auth__input"
            type="password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            autoComplete="new-password"
            required
          />
        </label>

        <label className="auth__label">
          Potvrdit heslo
          <input
            className="auth__input"
            type="password"
            value={confirm}
            onChange={(event) => setConfirm(event.target.value)}
            autoComplete="new-password"
            required
          />
        </label>

        {error && <p className="auth__error" role="alert">{error}</p>}

        <button className="button button--primary" type="submit" disabled={submitting}>
          {submitting ? 'Ukládám…' : 'Nastavit nové heslo'}
        </button>
      </form>
    </div>
  );
}
